export default __webpack_public_path__ + "static/media/Dispenser Housing  - Control Cage.aebe748c.jpg";